import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import {Box} from '@tenancy.nz/ui';

const HEADER_HEIGHT = 75;

function BannerContentLayout({
  content,
  disableBannerOnMobile = false,
  footer = null,
  imgSrc = undefined,
  offsetTop = 0,
  sx = {},
}) {
  const bannerTop = HEADER_HEIGHT + offsetTop;

  return (
    <Stack
      sx={{
        flexDirection: {xs: 'column-reverse', md: 'row'},
        flex: {md: 1},
        bgcolor: {xs: '#ffffff', md: '#f5f5f5'},
        ...sx,
      }}>
      <Stack flex={{md: 1}} position="relative">
        <Stack
          flex={1}
          justifyContent="center"
          alignItems="center"
          padding={{xs: '32px 16px', md: '16px 32px'}}>
          {content}
        </Stack>
        {footer && (
          <Box
            sx={{
              bgcolor: {xs: '#ffffff', md: '#f5f5f5'},
              width: '100%',
              mt: 'auto',
            }}>
            {footer}
          </Box>
        )}
      </Stack>
      <Box
        sx={{
          bgcolor: '#E1E1E1',
          width: {xs: '100%', md: '36.40%'},
          maxWidth: {md: '700px'},
          height: {
            xs: '364px',
            sm: '556px',
            md: `calc(100vh - ${bannerTop}px)`,
          },
          position: {md: 'sticky'},
          top: {md: bannerTop},
          alignSelf: 'flex-start',
          display: {xs: disableBannerOnMobile ? 'none' : 'block', md: 'block'},
          ...(imgSrc && {
            backgroundImage: `url(${imgSrc})`,
            backgroundSize: 'cover',
            backgroundPosition: {xs: 'center 60%', md: 'center'},
            backgroundRepeat: 'no-repeat',
          }),
        }}
      />
    </Stack>
  );
}

BannerContentLayout.propTypes = {
  content: PropTypes.node.isRequired,
  disableBannerOnMobile: PropTypes.bool,
  footer: PropTypes.node,
  imgSrc: PropTypes.string,
  offsetTop: PropTypes.number,
  sx: PropTypes.shape({}),
};

BannerContentLayout.defaultProps = {
  disableBannerOnMobile: false,
  footer: null,
  imgSrc: undefined,
  offsetTop: 0,
  sx: {},
};

export default BannerContentLayout;
